/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";

export class LottieVisualObjectModel<
  T extends LottieVisualObjectModel.IJson = LottieVisualObjectModel.IJson,
> extends JsonModel<T> {}

export namespace LottieVisualObjectModel {
  /**
   * Represents a Visual Object.
   */
  export interface IJson {
    /**
     * Name, as seen from editors and the like.
     */
    nm?: string;

    /**
     * Match name, used in expressions.
     */
    mn?: string;
  }
}
/* v8 ignore stop */
